export default __webpack_public_path__ + "media/images/brighteon-social/Icon-News-Gray-7baa87e528064c5256c8b340f515c84f.svg";